/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {ChecklistCosoPrincipioDTO} from './ChecklistCosoPrincipioDTO';

/**
 * The ChecklistCosoFattoreQualificanteDTO model module.
 * @module model/ChecklistCosoFattoreQualificanteDTO
 * @version v0
 */
export class ChecklistCosoFattoreQualificanteDTO {
  /**
   * Constructs a new <code>ChecklistCosoFattoreQualificanteDTO</code>.
   * @alias module:model/ChecklistCosoFattoreQualificanteDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ChecklistCosoFattoreQualificanteDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ChecklistCosoFattoreQualificanteDTO} obj Optional instance to populate.
   * @return {module:model/ChecklistCosoFattoreQualificanteDTO} The populated <code>ChecklistCosoFattoreQualificanteDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ChecklistCosoFattoreQualificanteDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('checklistCosoPrincipi'))
        obj.checklistCosoPrincipi = ApiClient.convertToType(data['checklistCosoPrincipi'], [ChecklistCosoPrincipioDTO]);
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
ChecklistCosoFattoreQualificanteDTO.prototype.id = undefined;

/**
 * @member {Number} position
 */
ChecklistCosoFattoreQualificanteDTO.prototype.position = undefined;

/**
 * @member {String} title
 */
ChecklistCosoFattoreQualificanteDTO.prototype.title = undefined;

/**
 * @member {Array.<module:model/ChecklistCosoPrincipioDTO>} checklistCosoPrincipi
 */
ChecklistCosoFattoreQualificanteDTO.prototype.checklistCosoPrincipi = undefined;

